import React from 'react'

export default class IconLogoGreenGeeks extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'

        return (
            <svg
                className={className}
                style={this.props.style}
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <rect width='24' height='24' rx='6' fill='#2CB344' />
                <path fillRule='evenodd' clipRule='evenodd' d='M2 3.3335H22V21.1113H2V3.3335Z' fill='#2CB344' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M13.1111 7.11133V11.1113H17.1111V13.3336H13.1111V17.3336H10.8889V13.3336H6.88892V11.1113H10.8889V7.11133H13.1111Z'
                    fill='white'
                />
            </svg>
        )
    }
}
